import { Component, EventEmitter, Inject, OnInit, Output, ViewChild } from '@angular/core';
import { ProgressNotesService } from 'src/app/Services/NewVisitNote/progress-notes.service';
import { IEncounterData } from 'src/app/models/IEncounterData';
import { MatTableDataSource, MatPaginator, MatSort, Sort, MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { CommonComponents } from 'src/app/Sharedservice/CommonComponents';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AESAlgorithm } from 'src/app/Utilities/Crypto/AESAlgorithm';
import { Defaults } from 'src/app/Utilities/defaults';
import { SharedService } from 'src/app/Sharedservice/SharedService';
import { IAlerts } from 'src/app/models/IAlerts';
import { PopupAlertsComponent } from 'src/app/ChildControls/popup-alerts/popup-alerts.component';
import { DatePipe } from '@angular/common';
import { GetCCDAMessageComponent } from 'src/app/CCDA/get-ccdamessage/get-ccdamessage.component';
import { IClinicTimeZone } from 'src/app/models/IClinicTimeZone';
import { LocationsService } from 'src/app/Services/AdminConfigurations/locations.service';
import { ILocationDetails } from 'src/app/models/ILocationDetails';
import { BehaviourSerService } from 'src/app/behaviour-ser.service';
declare let $: any;

@Component({
  selector: 'app-past-notes',
  templateUrl: './past-notes.component.html',
  styleUrls: ['./past-notes.component.css']
  //entryComponents:[GetCCDAMessageComponent]
})
export class PastNotesComponent implements OnInit {
  PastNotesForm: FormGroup;
  // displayedColumns: string[] = ['VisitDate','VisitType','Type', 'BillingProvider','RenderingProvider','Procedures','Status','SignedBy','DateofSign','Diagnosis','Action'];
  displayedColumns: string[] = ['dateVisit', 'appVisitType', 'encounterType', 'billingProvider', 'providerName', 'encounterStatus', 'signedBy', 'signedDate', 'locationName'];//, 'Action'];

  dataSource = new MatTableDataSource();
  visitDateFilter = new FormControl('');
  visitTypeFilter = new FormControl('');
  typeFilter = new FormControl('');
  billingFilter = new FormControl('');
  renderingFilter = new FormControl('');
  statusFilter = new FormControl('');
  signedByFilter = new FormControl('');
  dateofSignFilter = new FormControl('');
  diagnosisFilter = new FormControl('');
  locationFilter = new FormControl('');
  public lstPopUpAlerts: IAlerts[];
  public PopUpAlerts: IAlerts[] = [];
  public lstalerts: IAlerts[];
  selectedList: ILocationDetails[] = [];
  public allLocations: ILocationDetails[];
  rolealert: string = "";
  role: string = "";
  isdirect: boolean = false;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  // @Output() locationIdForPastEncounter = new EventEmitter<string>();

  filterValues = {
    dateVisit: '',
    appVisitType: '',
    encounterType: '',
    billingProvider: '',
    providerName: '',
    encounterStatus: '',
    signedBy: '',
    signedDate: '',
    encDiagnosis: '',
    locationName: '',
  };
  constructor(private pastencountersService: ProgressNotesService,
    private bhvsrv: BehaviourSerService,
    private router: Router,
    private sharedService: SharedService,
    public dialog: MatDialog,
    private toastr: ToastrService,
    private crypto: AESAlgorithm,
    private datePipe: DatePipe,
    private formBuilder: FormBuilder
    , private locationService: LocationsService
    , public dialogRef: MatDialogRef<PastNotesComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    //this.getPastEncounters();
    this.getSystem();
    this.getLocations();
    this.role = sessionStorage.getItem("role");
    if (data) {
      this.isdirect = data.isdirect;
    }
  }
  getSystem() {
    if (sessionStorage.getItem("encounterid") != null || sessionStorage.getItem("encounterid") != undefined) {
      CommonComponents.encounterId = sessionStorage.getItem("encounterid");
    }
  }

  ngOnInit() {
    $('#locationsfocusnew').on('focus', function () {
      $('#locationfocushide').show();
    });
    $(document).click(function (event) {
      if (event.target.id != "locationsfocusnew") {
        var container = $("#locationfocushide");
        if (!container.is(event.target) && !container.has(event.target).length) {
          container.hide();
        }
      }
    });
    this.PastNotesForm = this.formBuilder.group({
      locationId: [''],
      IsLocationCheck: [''],
    });
    this.visitDateFilter.valueChanges
      .subscribe(dateVisit => {
        this.filterValues.dateVisit = dateVisit;
        this.dataSource.filter = JSON.stringify(this.filterValues);
      })
    this.visitTypeFilter.valueChanges
      .subscribe(appVisitType => {
        this.filterValues.appVisitType = appVisitType;
        this.dataSource.filter = JSON.stringify(this.filterValues);
      })
    this.typeFilter.valueChanges
      .subscribe(encounterType => {
        this.filterValues.encounterType = encounterType;
        this.dataSource.filter = JSON.stringify(this.filterValues);
      })
    this.billingFilter.valueChanges
      .subscribe(billingProvider => {
        this.filterValues.billingProvider = billingProvider;
        this.dataSource.filter = JSON.stringify(this.filterValues);
      })
    this.renderingFilter.valueChanges
      .subscribe(providerName => {
        this.filterValues.providerName = providerName;
        this.dataSource.filter = JSON.stringify(this.filterValues);
      })
    this.statusFilter.valueChanges
      .subscribe(encounterStatus => {
        this.filterValues.encounterStatus = encounterStatus;
        this.dataSource.filter = JSON.stringify(this.filterValues);
      })
    this.signedByFilter.valueChanges
      .subscribe(signedBy => {
        this.filterValues.signedBy = signedBy;
        this.dataSource.filter = JSON.stringify(this.filterValues);
      })
    this.dateofSignFilter.valueChanges
      .subscribe(signedDate => {
        this.filterValues.signedDate = signedDate;
        this.dataSource.filter = JSON.stringify(this.filterValues);
      })
    this.diagnosisFilter.valueChanges
      .subscribe(encDiagnosis => {
        this.filterValues.providerName = encDiagnosis;
        this.dataSource.filter = JSON.stringify(this.filterValues);
      })
    this.locationFilter.valueChanges
      .subscribe(locationName => {
        this.filterValues.locationName = locationName;
        this.dataSource.filter = JSON.stringify(this.filterValues);
      })
  }

  getPastEncounters(selectedlocIds) {
    if (CommonComponents.patientId != undefined && CommonComponents.patientId != 0 && !Number.isNaN(CommonComponents.patientId)) {
      this.pastencountersService.getPastEncounters(CommonComponents.patientId, 0, selectedlocIds).subscribe(
        (pastEncounters: IEncounterData[]) => {
          pastEncounters.forEach(element => {

            if (element.signedByDate != null) {
              //  var datetime = this.datePipe.transform(element.signedByDate, 'dd/MM/yyyy hh:mm');
              var datetime = this.datePipe.transform(element.signedByDate, 'MM/dd/yyyy hh:mm a');
              element.signedDate = datetime;
            }
          });
          this.dataSource.data = pastEncounters;
          this.dataSource.filterPredicate = this.createFilter();
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        });
    }
    else {
      this.toastr.warning("Please select Patient Id");
    }
  }
  transform(value: string): string {
    if (value && value != undefined) {
      var datePipe = new DatePipe("en-US");
      value = datePipe.transform(value, 'MM/dd/yyyy');
    }
    return value;
  }

  createFilter(): (data: any, filter: string) => boolean {
    let filterFunction = function (data, filter): boolean {
      let searchTerms = JSON.parse(filter);
      return data.dateVisit.toLowerCase().indexOf(searchTerms.dateVisit) !== -1
        && data.appVisitType.toString().toLowerCase().indexOf(searchTerms.appVisitType.toLowerCase()) !== -1
        && data.encounterType.toLowerCase().indexOf(searchTerms.encounterType.toLowerCase()) !== -1
        && data.billingProvider.toLowerCase().indexOf(searchTerms.billingProvider.toLowerCase()) !== -1
        && data.providerName.toLowerCase().indexOf(searchTerms.providerName.toLowerCase()) !== -1
        && data.encounterStatus.toLowerCase().indexOf(searchTerms.encounterStatus.toLowerCase()) !== -1
        && data.signedBy.toLowerCase().indexOf(searchTerms.signedBy.toLowerCase()) !== -1
        && (data.signedDate === null ? "" : data.signedDate).toString().toLowerCase().indexOf(searchTerms.signedDate) !== -1
        && data.encDiagnosis.toLowerCase().indexOf(searchTerms.encDiagnosis.toLowerCase()) !== -1
        && (data.locationName == null ? "" : data.locationName.toLowerCase()).indexOf(searchTerms.locationName.toLowerCase()) !== -1;
    }
    return filterFunction;
  }
  selectedLoc: string;
  Navigate(ele: any) {
    sessionStorage.removeItem("visitType");
    sessionStorage.setItem("visitType", ele.appVisitType);
    sessionStorage.removeItem("selectedProviders");
    this.selectedLoc = '';
    if (ele.locationId != null && ele.locationId != undefined) {
      this.selectedLoc = ele.locationId;
      sessionStorage.setItem("LocationId", ele.locationId);
    }
    else {
      this.selectedLoc = "41";
      sessionStorage.setItem("LocationId", "41");
    }
    this.bhvsrv.islocationChangedTime.next(this.selectedLoc);

    sessionStorage.setItem("displayappDate", ele.dateVisit);
    sessionStorage.setItem("displayappDate1", ele.dateVisit);
    sessionStorage.setItem("pastnotedatetrue", "true");

    if (sessionStorage.getItem("displayappDate1") != null || sessionStorage.getItem("displayappDate1") != undefined) {
      sessionStorage.getItem("displayappDate1");
      sessionStorage.getItem("pastnotedatetrue");
    }
    if (localStorage.getItem("ordernoteheaderVisibility") != null)
      localStorage.removeItem("ordernoteheaderVisibility");
    if (sessionStorage.getItem("postFollowupVisibility") != null)
      sessionStorage.removeItem("postFollowupVisibility");
    this.displayPopupAlertsinClinic(CommonComponents.patientId, ele.dateVisit, ele.encounterType)
    if (ele && ele != undefined) {
      if (ele.pumpStatus == Defaults.pumpStatus_Active)
        sessionStorage.setItem("pumPRefillVisibility", "True");
      else {
        if (sessionStorage.getItem("pumPRefillVisibility") != null)
          sessionStorage.removeItem("pumPRefillVisibility");
      }
      if (ele.encounterType == Defaults.enc_VisitNoteType){
        sessionStorage.setItem("FormScreenType","VisitNote");
        this.router.navigateByUrl('/Visitnote?encounterId=' + encodeURIComponent(this.crypto.urlParmeterEncoder(ele.encounterId)) + '&&Type=Visit Note');
      }
       else if (ele.encounterType == Defaults.enc_ORNoteType) {
        sessionStorage.setItem("FormScreenType","ORNote");
        if (ele.encounterStatus == Defaults.appStatus_Completed)
          sessionStorage.setItem("postFollowupVisibility", "True");

        this.router.navigateByUrl('/ORNote?encounterId=' + encodeURIComponent(this.crypto.urlParmeterEncoder(ele.encounterId)) + '&&Type=OR Note');
      }
      else if (ele.encounterType = Defaults.enc_OrderNoteType) {
        sessionStorage.removeItem("rxfromsearch");
        sessionStorage.setItem("encounterid", ele.encounterId);
        localStorage.setItem("ordernoteheaderVisibility", "True");
        CommonComponents.headerVisibility = false;
        CommonComponents.ordernoteheaderVisibility = true;
        this.router.navigateByUrl('/OrderNote?id=' + encodeURIComponent(this.crypto.urlParmeterEncoder(sessionStorage.getItem("encounterid"))) + '&&Type=Order Note');
      }
    }
  }

  displayPopupAlertsinClinic(patId: number, visitDate: any, Action: any) {
    if (patId > 0) {
      this.sharedService.lstPopUpAlerts = null;
      this.sharedService.getAlertsInfo(patId, visitDate)
        .subscribe(
          (data: any) => {
            this.lstPopUpAlerts = data;
            this.sharedService.lstPopUpAlerts = this.lstPopUpAlerts;
            if (this.sharedService.lstPopUpAlerts != null && this.sharedService.lstPopUpAlerts.length > 0) {
              if (Action.includes("VisitNotes")) {
                var alertcount = this.sharedService.lstPopUpAlerts.filter((attr: IAlerts) => attr.isVisitNote == true && attr.isDismiss == true);
              } else if (Action.includes("OrderNote")) {
                var alertcount = this.sharedService.lstPopUpAlerts.filter((attr: IAlerts) => attr.isOrderNote == true && attr.isDismiss == true);
              }
              else {
                var alertcount = this.sharedService.lstPopUpAlerts.filter((attr: IAlerts) => attr.isOrNote == true && attr.isDismiss == true);
              }
              //var alertcount = this.sharedService.lstPopUpAlerts.filter((attr: IAlerts) => attr.isClinical == true && attr.isDismiss == true);
              alertcount = alertcount.filter((attr: IAlerts) => !attr.rolesName || attr.rolesName.includes(sessionStorage.getItem("role")));
              if (alertcount != null && alertcount.length > 0) {
                this.PopUpAlerts = alertcount;
                this.rolealert = "";
                this.PopUpAlerts.forEach(element => {
                  if (element.rolesName != null && element.rolesName != "") {
                    this.rolealert += element.rolesName + ',';
                  }
                });
                if (this.rolealert != null && this.rolealert != undefined && this.rolealert != "") {
                  if (this.rolealert.includes(sessionStorage.getItem("role"))) {
                    this.openAlertsPopup();
                  }
                } else {
                  this.openAlertsPopup();
                }
              }
            }
          },
          (err: any) => console.log(err)
        );
    }
  }

  openAlertsPopup(): void {
    const dialogRef = this.dialog.open(PopupAlertsComponent, {
      width: '1000px',
      height: '500px',
      data: this.PopUpAlerts
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result != undefined)
        { }
    });
  }

  oncellclick(element) {
    // this.dialogRef.close(element);
  }
  fnGenerateCDA(element) {
    const dialogRef = this.dialog.open(GetCCDAMessageComponent, {
      width: '950px',
      height: '900px',
      data: { patientid: CommonComponents.patientId, encounterid: element.encounterId, isdirect: this.isdirect }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result != undefined)
        { }
      this.dialogRef.close(result);
    });
  }

  getLocations() {
    this.sharedService.getLocationsByUser().subscribe(data => {
      this.allLocations = data.sort((a, b) => a.locationName.localeCompare(b.locationName));
      this.checkAlllocations();
      this.getPastEncounters(this.locselected);
    });
  }
  checkAlllocations() {
    this.locselected = '';
    this.selectedList = this.allLocations;
    this.locanames = '';
    for (let index = 0; index < this.selectedList.length; index++) {
      this.locselected += this.selectedList[index].locationId + ',';
      this.locanames += this.selectedList[index].locationName + ', ';
      this.selectedList[index].selected = true;
    }
    if (this.selectedList.length != 0) {
      this.locanames = this.locanames.substring(0, this.locanames.length - 2);
      this.locselected = this.locselected.substring(0, this.locselected.length - 1);
      this.PastNotesForm.patchValue({
        locationId: this.locanames,
      })
    }
    else {
      this.PastNotesForm.patchValue({
        locationId: ''
      })
    }
    this.checkDefaultLocation();
  }

  locselected: string = '';
  public locanames: string = '';
  selectedlocactions: string = '';
  checkSelectAllLocations(event) {
    let ischk: any
    if (event.keyCode == 32) {
      ischk = !event.target.checked
    } else {
      ischk = event.target.checked
    }
    if (ischk == true) {
      this.selectedlocactions = '';
      this.locanames = '';
      this.locselected = '';
      this.selectedList = [];
      this.selectedList = this.allLocations;
      this.selectedList.filter(x => x.selected = false);
      for (let index = 0; index < this.selectedList.length; index++) {
        this.selectedlocactions += this.selectedList[index].locationId + ',';
        this.locselected += this.selectedList[index].locationId + ',';
        this.locanames += this.selectedList[index].locationName + ', ';
        this.selectedList[index].selected = true;
      }
      if (this.selectedList.length != 0) {
        this.locanames = this.locanames.substring(0, this.locanames.length - 2);
        this.locselected = this.locselected.substring(0, this.locselected.length - 1);
        this.PastNotesForm.patchValue({
          locationId: this.locanames,
        })
      }
      else {
        this.PastNotesForm.patchValue({
          locationId: ''
        })
      }
    } else {
      for (let index = 0; index < this.selectedList.length; index++) {
        this.selectedList[index].selected = false;
      }
      this.locselected = '';
      this.locanames = '';
      this.selectedlocactions = '';
      if (this.selectedList.length != 0) {
        this.locanames = this.locanames.substring(0, this.locanames.length - 2);
        this.PastNotesForm.patchValue({
          locationId: this.locanames,
        })
      }
      else {
        this.PastNotesForm.patchValue({
          locationId: ''
        })
      }
    }
    this.getPastEncounters(this.locselected);
  }
  getlocationbasedproviders(locRef) {
    this.selectedList = [];
    this.locselected = '';
    this.locanames = '';
    this.selectedlocactions = '';
    this.selectedList = locRef.selectedOptions.selected.map(item => item.value);
    this.allLocations.filter(x => x.selected = false);
    this.selectedList.forEach(element => {
      this.allLocations.filter(x => x.locationId == element.locationId).map(y => y.selected = true)
    });
    for (let index = 0; index < this.selectedList.length; index++) {
      this.selectedlocactions += this.selectedList[index].locationId + ',';
      this.locselected += this.selectedList[index].locationId + ',';
      this.locanames += this.selectedList[index].locationName + ', ';
    }
    if (this.selectedList.length != 0) {
      this.locanames = this.locanames.substring(0, this.locanames.length - 2);
      this.locselected = this.locselected.substring(0, this.locselected.length - 1);
      this.PastNotesForm.patchValue({
        locationId: this.locanames,
      })
    }
    else {
      this.PastNotesForm.patchValue({
        locationId: ''
      })
    }
    this.checkDefaultLocation();
    this.getPastEncounters(this.locselected);
  }
  checkDefaultLocation() {
    if (this.selectedList.length > 0 && this.selectedList != undefined) {
      var selectProvlst = this.selectedList.filter(x => x.selected == true);
      if (selectProvlst.length === this.allLocations.length) {
        this.PastNotesForm.patchValue({
          IsLocationCheck: true
        });
      } else {
        this.PastNotesForm.patchValue({
          IsLocationCheck: false
        });
      }
    } else {
      this.PastNotesForm.patchValue({
        IsLocationCheck: false
      });
    }
  }

  focusOutFunctionlocations(evn) {
    if (evn.keyCode === 9) {
      $('#locationfocushide').hide()
    } else if (evn.keyCode === 40 && evn.target.id == "locationsfocusnew") {
      $('#loclistoption0').focus();
    }
  }
  onSelectionChanged(event, type: string) {
    setTimeout(() => {
      if (event !== null && event !== undefined) {
        $(event.target).prev().trigger('focus');
      }
    }, 100);
  }
  // checkAlllocations() {
  //   this.locselected = '';
  //   this.selectedList = this.allLocations;
  //   this.locanames = '';
  //   for (let index = 0; index < this.selectedList.length; index++) {
  //     this.locselected += this.selectedList[index].locationId + ',';
  //     this.locanames += this.selectedList[index].locationName + ', ';
  //     this.selectedList[index].selected = true;
  //   }
  //   if (this.selectedList.length != 0) {
  //     this.locanames = this.locanames.substring(0, this.locanames.length - 2);
  //     this.locselected = this.locselected.substring(0, this.locselected.length - 1);
  //     this.PastNotesForm.patchValue({
  //       locationId: this.locanames,
  //     })
  //   }
  //   else {
  //     this.PastNotesForm.patchValue({
  //       locationId: ''
  //     })
  //   }
  //   this.checkDefaultLocation();
  // }

  // locselected: string = '';
  // public locanames: string = '';
  // selectedlocactions: string = '';
  // checkSelectAllLocations(event) {
  //   let ischk: any
  //   if (event.keyCode == 32) {
  //     ischk = !event.target.checked
  //   } else {
  //     ischk = event.target.checked
  //   }
  //   if (ischk == true) {
  //     this.selectedlocactions = '';
  //     this.locanames = '';
  //     this.locselected = '';
  //     this.selectedList = [];
  //     this.selectedList = this.allLocations;
  //     this.selectedList.filter(x => x.selected = false);
  //     for (let index = 0; index < this.selectedList.length; index++) {
  //       this.selectedlocactions += this.selectedList[index].locationId + ',';
  //       this.locselected += this.selectedList[index].locationId + ',';
  //       this.locanames += this.selectedList[index].locationName + ', ';
  //       this.selectedList[index].selected = true;
  //     }
  //     if (this.selectedList.length != 0) {
  //       this.locanames = this.locanames.substring(0, this.locanames.length - 2);
  //       this.locselected = this.locselected.substring(0, this.locselected.length - 1);
  //       this.PastNotesForm.patchValue({
  //         locationId: this.locanames,
  //       })
  //     }
  //     else {
  //       this.PastNotesForm.patchValue({
  //         locationId: ''
  //       })
  //     }
  //   } else {
  //     for (let index = 0; index < this.selectedList.length; index++) {
  //       this.selectedList[index].selected = false;
  //     }
  //     this.locselected = '';
  //     this.locanames = '';
  //     this.selectedlocactions = '';
  //     if (this.selectedList.length != 0) {
  //       this.locanames = this.locanames.substring(0, this.locanames.length - 2);
  //       this.PastNotesForm.patchValue({
  //         locationId: this.locanames,
  //       })
  //     }
  //     else {
  //       this.PastNotesForm.patchValue({
  //         locationId: ''
  //       })
  //     }
  //   }
  //   this.getPastEncounters(this.locselected);
  // }
  // getlocationbasedproviders(locRef) {
  //   this.selectedList = [];
  //   this.locselected = '';
  //   this.locanames = '';
  //   this.selectedlocactions = '';
  //   this.selectedList = locRef.selectedOptions.selected.map(item => item.value);
  //   this.allLocations.filter(x => x.selected = false);
  //   this.selectedList.forEach(element => {
  //     this.allLocations.filter(x => x.locationId == element.locationId).map(y => y.selected = true)
  //   });
  //   for (let index = 0; index < this.selectedList.length; index++) {
  //     this.selectedlocactions += this.selectedList[index].locationId + ',';
  //     this.locselected += this.selectedList[index].locationId + ',';
  //     this.locanames += this.selectedList[index].locationName + ', ';
  //   }
  //   if (this.selectedList.length != 0) {
  //     this.locanames = this.locanames.substring(0, this.locanames.length - 2);
  //     this.locselected = this.locselected.substring(0, this.locselected.length - 1);
  //     this.PastNotesForm.patchValue({
  //       locationId: this.locanames,
  //     })
  //   }
  //   else {
  //     this.PastNotesForm.patchValue({
  //       locationId: ''
  //     })
  //   }
  //   this.checkDefaultLocation();
  //   this.getPastEncounters(this.locselected);
  // }
  // checkDefaultLocation() {
  //   if (this.selectedList.length > 0 && this.selectedList != undefined) {
  //     var selectProvlst = this.selectedList.filter(x => x.selected == true);
  //     if (selectProvlst.length === this.allLocations.length) {
  //       this.PastNotesForm.patchValue({
  //         IsLocationCheck: true
  //       });
  //     } else {
  //       this.PastNotesForm.patchValue({
  //         IsLocationCheck: false
  //       });
  //     }
  //   } else {
  //     this.PastNotesForm.patchValue({
  //       IsLocationCheck: false
  //     });
  //   }
  // }

  // focusOutFunctionlocations(evn) {
  //   if (evn.keyCode === 9) {
  //     $('#locationfocushide').hide()
  //   } else if (evn.keyCode === 40 && evn.target.id == "locationsfocusnew") {
  //     $('#loclistoption0').focus();
  //   }
  // }
  // onSelectionChanged(event, type: string) {
  //   setTimeout(() => {
  //     if (event !== null && event !== undefined) {
  //       $(event.target).prev().trigger('focus');
  //     }
  //   }, 100);
  // }
}
